<template>
  <div class="container">
    <!-- Search Box and Button -->
    <!-- <div class="dropdown-container">
      <div class="dropdown-item">
        <label for="fsmSelect">FSM</label>
        <select id="fsmSelect" v-model="selectedFsm" @change="loadAsmList">
          <option value="">Select FSM</option>
          <option v-for="fsm in fsmList" :key="fsm.id" :value="fsm.profile_id">
            {{ fsm.name }}
          </option>
        </select>
      </div>

      <div class="dropdown-item">
        <label for="asmSelect">ASM</label>
        <select id="asmSelect" v-model="selectedAsm" @change="loadDistributorList">
          <option value="">Select ASM</option>
          <option v-for="asm in asmList" :key="asm.id" :value="asm.profile_id">
            {{ asm.name }}
          </option>
        </select>
      </div>

      <div class="dropdown-item">
        <label for="distributorSelect">Distributor</label>
        <select id="distributorSelect" v-model="selectedDistributor" @change="loadDealerList">
          <option value="">Select Distributor</option>
          <option v-for="distributor in distributorList" :key="distributor.id" :value="distributor.profile_id">
            {{ distributor.name }}
          </option>
        </select>
      </div>

      <div class="dropdown-item">
        <label for="dealerSelect">Dealer</label>
        <select id="dealerSelect" v-model="selectedDealer">
          <option value="">All Dealers</option>
          <option v-for="dealer in dealerList" :key="dealer.profile_id" :value="dealer.profile_id">
            {{ dealer.name }}
          </option>
        </select>
      </div>

      
      <div class="dropdown-item">
        <label for="startDatePicker">Start Date</label>
        <input
            type="date"
            v-model="startDate"
            class="search-input"
            @change="handleDateChange"
        />
      </div>

      <div class="dropdown-item">
        <label for="endDatePicker">End Date</label>
        <input
            type="date"
            v-model="endDate"
            class="search-input"
            @change="handleDateChange"
        />
      </div>

      
      <div class="search-container">
        <button @click="performSearch" class="btn button-default mt-4">Search</button>
      </div>
    </div> -->

    <div class="dropdown-container">
      <!-- FSM -->
      <div class="dropdown-item">
        <label for="fsmSelect">FSM</label>
        <select id="fsmSelect" v-model="selectedFsm" @change="onFsmChange" :disabled="isFsmLocked">
          <option value="">Select FSM</option>
          <option v-if="isOtherUser" :value="ALL">All FSMs</option>

          <option v-for="fsm in fsmList" :key="fsm.profile_id ?? fsm.id" :value="String(fsm.profile_id)">
            {{ fsm.name }}
          </option>
        </select>
      </div>

      <!-- ASM -->
      <div class="dropdown-item">
        <label for="asmSelect">ASM</label>
        <select id="asmSelect" v-model="selectedAsm" @change="onAsmChange" :disabled="isAsmLocked">
          <option value="">Select ASM</option>
          <option v-if="isFsmUser || isOtherUser" :value="ALL">All ASMs</option>

          <option v-for="asm in asmList" :key="asm.profile_id ?? asm.id" :value="String(asm.profile_id)">
            {{ asm.name }}
          </option>
        </select>
      </div>

      <!-- Distributor -->
      <div class="dropdown-item">
        <label for="distributorSelect">Distributor</label>
        <select id="distributorSelect" v-model="selectedDistributor" @change="onDistributorChange"
          :disabled="isDistributorLocked">
          <option value="">Select Distributor</option>
          <option v-if="isFsmUser || isAsmUser || isOtherUser" :value="ALL">All Distributors</option>

          <option v-for="distributor in distributorList" :key="distributor.profile_id ?? distributor.id"
            :value="String(distributor.profile_id)">
            {{ distributor.name }}
          </option>
        </select>
      </div>

      <!-- Dealer -->
      <div class="dropdown-item">
        <label for="dealerSelect">Dealer</label>
        <select id="dealerSelect" v-model="selectedDealer" :disabled="!canUseDealerFilter">
          <option value="">All Dealers</option>
          <option v-for="dealer in dealerList" :key="dealer.profile_id ?? dealer.id" :value="String(dealer.profile_id)">
            {{ dealer.name }}
          </option>
        </select>
      </div>

      <!-- Start Date -->
      <div class="dropdown-item">
        <label for="startDatePicker">Start Date</label>
        <input type="date" v-model="startDate" class="search-input" :max="currentDate" @change="handleDateChange"
          @blur="validateStartDate(true)" />
      </div>

      <!-- End Date -->
      <div class="dropdown-item">
        <label for="endDatePicker">End Date</label>
        <input type="date" v-model="endDate" class="search-input" :max="currentDate" @change="handleDateChange"
          @blur="validateEndDate(true)" />
      </div>

      <!-- Search -->
      <div class="search-container">
        <button @click="performSearch" class="btn button-default mt-4" :disabled="isLoading">
          {{ isLoading ? "Searching..." : "Search" }}
        </button>

        <button v-if="searchedOnce && filteredComplaintList.length" 
                @click="exportToExcel" 
                class="btn btn-success export-btn mt-4">
          Export to Excel
        </button>
      </div>
    </div>


    <!-- Loading Spinner -->
    <div v-if="isLoading" class="loading-spinner">
      <i class="fa fa-spinner fa-spin"></i> Loading...
    </div>

    <!-- Complaint Table -->
    <div v-else-if="searchedOnce && filteredComplaintList.length" class="table-container">
      <div class="card">
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr class="border-bottom-primary">
                <th rowspan="2">Dealer Name</th>
                <th rowspan="2">Remark</th>
                <th rowspan="2">Date | Time</th>
                <th rowspan="2">Visited by</th>
                <th :colspan="uniqueChecklists.length" class="text-center border-right-main">Checklist</th>
                <th rowspan="2" class="border-right-main no-bottom-border">Qty Type</th>
                <th :colspan="uniqueItems.length" class="text-center">Items</th>
              </tr>
              <tr>
                <!-- Checklist sub columns -->
                <th v-for="(check, idx) in uniqueChecklists" 
                    :key="'check-'+check.name"
                    :class="{'border-right-main': idx === uniqueChecklists.length - 1}">
                  {{ check.name }}
                </th>

                <!-- Item sub columns -->
                <th v-for="item in uniqueItems" :key="'item-'+item.id">
                  {{ item.name }}
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(visit, index) in filteredComplaintList" :key="index">
                <template v-for="(rowType, rIndex) in ['Sale Qty', 'Empty Qty', 'Refill Qty']" :key="rIndex">
                  <tr>
                    <!-- Dealer info & checklist: rowspan 3 -->
                    <td v-if="rowType === 'Sale Qty'" :rowspan="3">{{ visit.business_name }}</td>
                    <td v-if="rowType === 'Sale Qty'" :rowspan="3">{{ visit.remark }}</td>
                    <td v-if="rowType === 'Sale Qty'" :rowspan="3">{{ visit.created_at }}</td>
                    <td v-if="rowType === 'Sale Qty'" :rowspan="3">{{ visit.visited }}</td>

                    <!-- Checklist columns: rowspan 3 -->
                    <td v-if="rowType === 'Sale Qty'" :rowspan="3" v-for="check in uniqueChecklists" :key="'check-'+check.name" class="text-center">
                      <i v-if="visit.dealerCheckListDetails?.find(c => c.checklists === check.name)?.list_value === '1'" 
                        class="fa fa-check" style="color: green;"></i>
                      <i v-else-if="visit.dealerCheckListDetails?.find(c => c.checklists === check.name)?.list_value === '0'" 
                        class="fa fa-times" style="color: red;"></i>
                      <span v-else>-</span>
                    </td>

                    <!-- New Type Column -->
                    <td class="text-center">{{ rowType }}</td>

                    <!-- Items columns -->
                    <td v-for="item in uniqueItems" :key="'item-'+item.id" class="text-center">
                      {{
                        rowType === 'Sale Qty' 
                          ? visit.dealerVisititems?.find(i => i.item_id === item.id)?.sale_qty ?? '-'
                          : rowType === 'Empty Qty'
                            ? visit.dealerVisititems?.find(i => i.item_id === item.id)?.empty_qty ?? '-'
                            : visit.dealerVisititems?.find(i => i.item_id === item.id)?.refil_qty ?? '-'
                      }}
                    </td>
                  </tr>
                </template>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>


    <!-- ✅ After Search: No data message -->
    <div v-else-if="searchedOnce" class="no-data-message">
      No data found. Please change filters and click Search.
    </div>

    <!-- ✅ Before Search: don’t show table headers -->
    <div v-else class="no-data-message">
      Please select filters and click Search.
    </div>

    <!-- Modal -->
    <Modal v-if="showModal" :visible="showModal" :title="modalTitle" :visited="modalVisited"
      :dealerName="modalDealerName" :remark="modalRemark" :dateTimeValue="modalDateTimeValue"
      :checklist="modalChecklist" :tableData="modalTableData" @close="showModal = false" />
  </div>
</template>

<script>
import { login } from '@/services/authService';
import {
  fetchFsmList,
  fetchAsmList,
  fetchDistributorList,
  fetchDealerList,
  searchdealervisit,
  fetchDealerListManagement,
  fetchDealerPopup
} from '@/services/dataService';
import Modal from '../../Modal/dealerVisitDetails.vue';
import { useToast } from "vue-toastification";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  components: {
    Modal,
  },

  data() {
    const today = new Date().toISOString().split('T')[0];
    const ALL = "__all__";

    return {
      token: localStorage.getItem('token_set') || '',
      fsmList: [],
      asmList: [],
      distributorList: [],
      dealerList: [],
      selectedFsm: '',
      selectedAsm: '',
      selectedDistributor: '',
      selectedDealer: '',
      selectedDate: '', // Added selectedDate for the date picker
      searchQuery: '',
      startDate: today, // Added for the start date picker
      endDate: today,   // Added for the end date picker
      complaintList: [],
      loading: false, // Track loading state

      ALL,
      userLabel: "",
      roleKey: "OTHER",
      myProfileId: Number(localStorage.getItem("profile_id") || 0),
      isFsmLocked: false,
      isAsmLocked: false,
      isDistributorLocked: false,


      loadingInit: false,  // page init loader
      loading: false,      // search loader
      searchedOnce: false, // controls table visibility

      showModal: false,
      modalTitle: '',
      modalDealerName: '',
      modalRemark: '',
      modalDateTimeValue: '',
      modalChecklist: [],
      modalSubCategory: '',
      modalTableData: [],
      modalVisited: '', // Add visited field
    };
  },


  created() {
    this.loginAndFetchData();
  },




  // computed: {
  //   filteredComplaintList() {
  //     // Ensure complaintList is defined before applying filter
  //     if (!Array.isArray(this.complaintList)) {
  //       return []; // Return an empty array if undefined
  //     }

  //     return this.complaintList.filter(complaint => {
  //       const complaintDate = new Date(complaint.created_at).toISOString().split('T')[0];
  //       const startDate = this.startDate ? new Date(this.startDate).toISOString().split('T')[0] : null;
  //       const endDate = this.endDate ? new Date(this.endDate).toISOString().split('T')[0] : null;

  //       if (startDate && endDate) {
  //         return complaintDate >= startDate && complaintDate <= endDate;
  //       } else if (startDate) {
  //         return complaintDate >= startDate;
  //       } else if (endDate) {
  //         return complaintDate <= endDate;
  //       } else {
  //         return true;
  //       }
  //     });
  //   }
  // },
  computed: {
    isDistributorUser() { return this.roleKey === "DIS"; },
    isAsmUser() { return this.roleKey === "ASM"; },
    isFsmUser() { return this.roleKey === "FSM"; },
    isOtherUser() { return this.roleKey === "OTHER"; },
    isLoading() { return this.loadingInit || this.loading; },

    // ✅ dealer enabled only when real distributor selected
    canUseDealerFilter() {
      return !!this.selectedDistributor && this.selectedDistributor !== this.ALL;
    },

    filteredComplaintList() {
      if (!Array.isArray(this.complaintList)) return [];

      return this.complaintList.filter(c => {
        const complaintDate = new Date(c.created_at).toISOString().split("T")[0];
        const s = this.startDate ? new Date(this.startDate).toISOString().split("T")[0] : null;
        const e = this.endDate ? new Date(this.endDate).toISOString().split("T")[0] : null;

        if (s && e) return complaintDate >= s && complaintDate <= e;
        if (s) return complaintDate >= s;
        if (e) return complaintDate <= e;
        return true;
      });
    },

    uniqueItems() {
      const itemsMap = new Map();

      this.filteredComplaintList.forEach(visit => {
        visit.dealerVisititems?.forEach(item => {
          if (!itemsMap.has(item.item_id)) {
            itemsMap.set(item.item_id, { id: item.item_id, name: item.item_name, values: [] });
          }
          itemsMap.get(item.item_id).values.push({
            sale: parseFloat(item.sale_qty) || 0,
            empty: parseFloat(item.empty_qty) || 0,
            refill: parseFloat(item.refil_qty) || 0,
          });
        });
      });

      const filtered = Array.from(itemsMap.values()).filter(item => {
        return item.values.some(v => v.sale > 0 || v.empty > 0 || v.refill > 0);
      });

      return filtered.map(item => ({ id: item.id, name: item.name }));
    },

    uniqueChecklists() {
      const lists = new Map();

      this.filteredComplaintList.forEach(visit => {
        visit.dealerCheckListDetails?.forEach(list => {
          if (!lists.has(list.checklists)) {
            lists.set(list.checklists, list.checklists);
          }
        });
      });

      return Array.from(lists, ([key, value]) => ({
        name: value
      }));
    }
  },


  // methodsold: {
  //   //Date Range Validation
  //   handleDateChange() {
  //     if (this.startDate && this.endDate) {
  //       const start = new Date(this.startDate);
  //       const end = new Date(this.endDate);

  //       if (end < start) {
  //         this.showErrorToast('Invalid date range picked.');
  //         this.endDate = ''; // Clear the invalid end date
  //       }
  //     }
  //   },

  //   //Show Error Message in Toaster
  //   showErrorToast(message) {
  //     const toast = useToast(); // Initialize toaster
  //     toast.error(message, {
  //       position: "top-right",
  //       timeout: 3000,
  //     });
  //   },

  //   async loginAndFetchData() {
  //     try {
  //       this.token = localStorage.getItem('token_set') || '';
  //       await this.loadFsmList();
  //     } catch (error) {
  //       console.error('Error fetching data:', error);
  //     }
  //   },
  //   async loadFsmList() {
  //     const profileId = localStorage.getItem('profile_id');
  //     if (!profileId) {
  //       console.error('Profile ID not found in localStorage');
  //       return;
  //     }
  //     try {
  //       const response = await fetchFsmList(profileId, this.token);
  //       this.fsmList = response.data.data || [];
  //     } catch (error) {
  //       console.error('Error loading FSM list:', error);
  //     }
  //   },
  //   async loadAsmList() {
  //     if (this.selectedFsm) {
  //       try {
  //         const profileId = localStorage.getItem('profile_id');
  //         const response = await fetchAsmList(profileId, this.selectedFsm, this.token);
  //         this.asmList = response.data.data || [];
  //         this.selectedAsm = '';
  //         this.selectedDistributor = '';
  //         this.selectedDealer = '';
  //       } catch (error) {
  //         console.error('Error loading ASM list:', error);
  //       }
  //     } else {
  //       this.asmList = [];
  //       this.selectedAsm = '';
  //       this.selectedDistributor = '';
  //       this.selectedDealer = '';
  //     }
  //   },
  //   async loadDistributorList() {
  //     if (this.selectedAsm) {
  //       try {
  //         const fsmId = this.selectedFsm;
  //         const response = await fetchDistributorList(fsmId, this.selectedAsm, this.token);
  //         this.distributorList = response.data.data || [];
  //         this.selectedDistributor = '';
  //         this.selectedDealer = '';
  //       } catch (error) {
  //         console.error('Error loading Distributor list:', error);
  //       }
  //     } else {
  //       this.distributorList = [];
  //       this.selectedDistributor = '';
  //       this.selectedDealer = '';
  //     }
  //   },
  //   async loadDealerListManagement() {
  //     if (this.selectedDistributor) {
  //       try {
  //         const profileId = localStorage.getItem('profile_id');
  //         const response = await fetchDealerListManagement(profileId, this.selectedDistributor, this.token);
  //         this.dealerList = response.data.data || [];
  //       } catch (error) {
  //         console.error('Error loading dealer_visit list:', error);
  //       }
  //     } else {
  //       this.dealerList = [];
  //     }
  //   },
  //   async loadDealerList() {
  //     if (this.selectedDistributor) {
  //       await this.loadDealerListManagement();
  //     } else {
  //       this.dealerList = [];
  //     }
  //   },
  //   async performSearch() {
  //     this.loading = true; // Start loading

  //     try {
  //       // Format the selected date as YYYY-MM-DD if a date is selected
  //       const formattedStartDate = this.startDate ? this.formatDateForApi(this.startDate) : null;
  //       const formattedEndDate = this.endDate ? this.formatDateForApi(this.endDate) : null;

  //       const response = await searchdealervisit({
  //         fsm_id: this.selectedFsm || null,
  //         asm_id: this.selectedAsm || null,
  //         distributor_id: this.selectedDistributor || null,
  //         dealer_id: this.selectedDealer || null,
  //         start_date: formattedStartDate,  // Passing the start date to the API
  //         end_date: formattedEndDate       // Passing the end date to the API
  //       }, this.token);

  //       this.complaintList = response.data.data;
  //     } catch (error) {
  //       console.error('Error searching dealer:', error);
  //     } finally {
  //       this.loading = false; // Stop loading when search is done
  //     }
  //   },
  //   // Format the date to YYYY-MM-DD for API requests
  //   formatDateForApi(dateString) {
  //     const date = new Date(dateString);
  //     const year = date.getFullYear();
  //     const month = ('0' + (date.getMonth() + 1)).slice(-2); // Add leading zero if needed
  //     const day = ('0' + date.getDate()).slice(-2); // Add leading zero if needed
  //     return `${year}-${month}-${day}`;
  //   },
  //   // Format the date for display
  //   formatDate(dateString) {
  //     const date = new Date(dateString);
  //     return date.toLocaleDateString('en-US');
  //   },
  //   async visitDetails(dealerVisitId) {
  //     try {
  //       const response = await fetchDealerPopup(dealerVisitId, this.token);
  //       const data = response.data.data;

  //       this.modalTitle = 'dealer_visit Visit Details';
  //       this.modalVisited = data.dealerVisit[0].visited;
  //       this.modalDealerName = data.dealerVisit[0].business_name;
  //       this.modalRemark = data.dealerVisit[0].remark;
  //       this.modalDateTimeValue = data.dealerVisit[0].created_at;
  //       this.modalChecklist = data.dealerCheckListDetails.map(item => ({
  //         id: item.id,
  //         name: item.checklists,
  //         list_value: item.list_value,
  //         details: item.details // Assuming `details` is the field containing additional information
  //       }));
  //       this.modalTableData = data.dealerVisititems.map(item => ({
  //         itemName: item.item_name,
  //         saleQty: item.sale_qty,
  //         refillQty: item.refil_qty,
  //         qty: item.empty_qty
  //       }));
  //       this.showModal = true;
  //     } catch (error) {
  //       console.error('Error fetching dealer visit details:', error);
  //     }
  //   }
  // },



  methods: {
    // =========================
    // ✅ TOAST HELPERS
    // =========================
    toast(type, message) {
      const t = useToast();
      if (type === "error") {
        t.error(message, { position: "top-right", timeout: 3000 });
      } else {
        t.success(message, { position: "top-right", timeout: 3000 });
      }
    },
    showErrorToast(message) {
      this.toast("error", message);
    },
    showSuccessToast(message) {
      this.toast("success", message);
    },

    // =========================
    // ✅ ROLE INIT (Distributor lock only)
    // =========================
    initRoleFromStorage() {
      // make sure ALL exists (if not defined in data)
      if (!this.ALL) this.ALL = "__all__";

      const labelFromStorage =
        localStorage.getItem("user_label") ||
        localStorage.getItem("userLabel") ||
        localStorage.getItem("role") ||
        "";

      this.userLabel = String(labelFromStorage || "");
      const u = this.userLabel.toUpperCase().trim();

      if (u === "DISTRIBUTOR" || u.startsWith("DISTRIBUTOR") || u === "DIS" || u.startsWith("DIS_")) this.roleKey = "DIS";
      else if (u === "ASM" || u.startsWith("ASM_")) this.roleKey = "ASM";
      else if (u === "FSM" || u.startsWith("FSM_")) this.roleKey = "FSM";
      else this.roleKey = "OTHER";

      this.myProfileId = Number(localStorage.getItem("profile_id") || 0);

      // default locks
      this.isFsmLocked = false;
      this.isAsmLocked = false;
      this.isDistributorLocked = false;
    },

    // =========================
    // ✅ FILTER VALIDATION
    // =========================
    validateFiltersOneByOne() {
      if (!this.selectedFsm) { this.showErrorToast("Please select FSM"); return false; }
      if (!this.selectedAsm) { this.showErrorToast("Please select ASM"); return false; }
      if (!this.selectedDistributor) { this.showErrorToast("Please select Distributor"); return false; }

      // distributor login must never use ALL
      if (this.roleKey === "DIS" && this.selectedDistributor === this.ALL) {
        this.showErrorToast("Please select Distributor");
        return false;
      }

      // Dealer optional (All Dealers allowed)
      return true;
    },

    // =========================
    // ✅ DATE VALIDATION (same style)
    // =========================
    isValidISODate(dateStr) {
      if (!dateStr || typeof dateStr !== "string") return false;
      if (dateStr.includes("/")) return false;

      const m = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (!m) return false;

      const y = Number(m[1]);
      const mo = Number(m[2]);
      const d = Number(m[3]);

      const dt = new Date(y, mo - 1, d);
      return dt.getFullYear() === y && dt.getMonth() === mo - 1 && dt.getDate() === d;
    },

    validateStartDate(showToast = true) {
      if (!this.startDate) return true;

      if (!this.isValidISODate(this.startDate)) {
        if (showToast) this.showErrorToast("Invalid Start Date");
        this.startDate = "";
        return false;
      }

      const maxDate = this.currentDate || new Date().toISOString().split("T")[0];
      if (this.startDate > maxDate) {
        if (showToast) this.showErrorToast("Start Date cannot be in the future");
        this.startDate = "";
        return false;
      }
      return true;
    },

    validateEndDate(showToast = true) {
      if (!this.endDate) return true;

      if (!this.isValidISODate(this.endDate)) {
        if (showToast) this.showErrorToast("Invalid End Date");
        this.endDate = "";
        return false;
      }

      const maxDate = this.currentDate || new Date().toISOString().split("T")[0];
      if (this.endDate > maxDate) {
        if (showToast) this.showErrorToast("End Date cannot be in the future");
        this.endDate = "";
        return false;
      }
      return true;
    },

    handleDateChange() {
      // silent validate first
      this.validateStartDate(false);
      this.validateEndDate(false);

      // range validate
      if (this.startDate && this.endDate && this.endDate < this.startDate) {
        this.showErrorToast("Invalid date range picked.");
        this.endDate = "";
      }
    },

    validateDatesForSearch() {
      if (!this.startDate) { this.showErrorToast("Please select valid Start Date"); return false; }
      if (!this.endDate) { this.showErrorToast("Please select valid End Date"); return false; }

      if (!this.validateStartDate(true)) return false;
      if (!this.validateEndDate(true)) return false;

      if (this.endDate < this.startDate) {
        this.showErrorToast("Invalid date range picked.");
        return false;
      }
      return true;
    },

    // =========================
    // ✅ INIT + DROPDOWN LOADERS (NO AUTO SELECT)
    // =========================
    async loginAndFetchData() {
      this.loadingInit = true;
      try {
        this.initRoleFromStorage();
        this.token = localStorage.getItem("token_set") || "";
        await this.loadFsmList();
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this.loadingInit = false;
      }
    },

    async loadFsmList() {
      const profileId = localStorage.getItem("profile_id");
      if (!profileId) {
        console.error("Profile ID not found in localStorage");
        return;
      }
      try {
        const response = await fetchFsmList(profileId, this.token);
        this.fsmList = response.data.data || [];

        // ✅ IMPORTANT: no auto-select on page load
        this.selectedFsm = "";
        this.selectedAsm = "";
        this.selectedDistributor = "";
        this.selectedDealer = "";

        this.asmList = [];
        this.distributorList = [];
        this.dealerList = [];

        this.isDistributorLocked = false;
      } catch (error) {
        console.error("Error loading FSM list:", error);
      }
    },

    // call this from @change on FSM
    async onFsmChange() {
      this.selectedAsm = "";
      this.selectedDistributor = "";
      this.selectedDealer = "";

      this.asmList = [];
      this.distributorList = [];
      this.dealerList = [];

      this.isDistributorLocked = false;

      if (!this.selectedFsm) return;
      if (this.selectedFsm === this.ALL) {
        // if you support ALL FSM, keep next filters as ALL too (optional)
        this.selectedAsm = this.ALL;
        this.selectedDistributor = this.ALL;
        return;
      }

      await this.loadAsmList();
    },

    async loadAsmList() {
      if (!this.selectedFsm || this.selectedFsm === this.ALL) {
        this.asmList = [];
        this.selectedAsm = "";
        this.selectedDistributor = "";
        this.selectedDealer = "";
        return;
      }

      try {
        const profileId = localStorage.getItem("profile_id");
        const response = await fetchAsmList(profileId, this.selectedFsm, this.token);

        this.asmList = response.data.data || [];

        // ✅ NO auto select ASM
        this.selectedAsm = "";
        this.selectedDistributor = "";
        this.selectedDealer = "";

        this.distributorList = [];
        this.dealerList = [];
        this.isDistributorLocked = false;
      } catch (error) {
        console.error("Error loading ASM list:", error);
      }
    },

    // call this from @change on ASM
    async onAsmChange() {
      this.selectedDistributor = "";
      this.selectedDealer = "";

      this.distributorList = [];
      this.dealerList = [];
      this.isDistributorLocked = false;

      if (!this.selectedAsm) return;

      if (this.selectedAsm === this.ALL) {
        this.selectedDistributor = this.ALL;
        return;
      }

      await this.loadDistributorList();
    },

    async loadDistributorList() {
      // reset down
      this.selectedDistributor = "";
      this.selectedDealer = "";
      this.distributorList = [];
      this.dealerList = [];
      this.isDistributorLocked = false;

      if (!this.selectedAsm) return;
      if (this.selectedAsm === this.ALL) {
        this.selectedDistributor = this.ALL;
        return;
      }

      try {
        const fsmId = this.selectedFsm;
        const response = await fetchDistributorList(fsmId, this.selectedAsm, this.token);

        let list = response.data.data || [];

        // ✅ ONLY distributor login: auto pick own distributor + lock it
        if (this.roleKey === "DIS" && this.myProfileId) {
          const mine = list.find(d => Number(d.profile_id) === Number(this.myProfileId));
          if (mine) {
            list = [mine];
            this.selectedDistributor = String(mine.profile_id);
            this.isDistributorLocked = true;

            // programmatic select won't trigger change -> load dealers
            await this.loadDealerList();
          }
        }

        // ✅ NO auto-select for non-distributor users (even if list length == 1)
        this.distributorList = list;
      } catch (error) {
        console.error("Error loading Distributor list:", error);
        this.distributorList = [];
        this.selectedDistributor = "";
        this.selectedDealer = "";
        this.isDistributorLocked = false;
      }
    },

    // call this from @change on Distributor
    async onDistributorChange() {
      this.selectedDealer = "";
      this.dealerList = [];

      if (!this.selectedDistributor) return;
      if (this.selectedDistributor === this.ALL) return;

      await this.loadDealerList();
    },

    async loadDealerList() {
      if (!this.selectedDistributor || this.selectedDistributor === this.ALL) {
        this.dealerList = [];
        this.selectedDealer = "";
        return;
      }
      await this.loadDealerListManagement();
    },

    async loadDealerListManagement() {
      if (!this.selectedDistributor || this.selectedDistributor === this.ALL) {
        this.dealerList = [];
        return;
      }

      try {
        const profileId = localStorage.getItem("profile_id");
        const response = await fetchDealerListManagement(profileId, this.selectedDistributor, this.token);
        this.dealerList = response.data.data || [];

        // Dealer default = All Dealers
        this.selectedDealer = "";
      } catch (error) {
        console.error("Error loading dealer_visit list:", error);
        this.dealerList = [];
      }
    },

    // =========================
    // ✅ SEARCH (validations only on click)
    // =========================
    async performSearch() {
      // ✅ validations only when user clicks
      if (!this.validateFiltersOneByOne()) return;
      if (!this.validateDatesForSearch()) return;

      this.loading = true;
      this.searchedOnce = true;
      this.complaintList = [];

      try {
        const formattedStartDate = this.formatDateForApi(this.startDate);
        const formattedEndDate = this.formatDateForApi(this.endDate);

        const payload = {
          fsm_id: (this.selectedFsm && this.selectedFsm !== this.ALL) ? this.selectedFsm : null,
          asm_id: (this.selectedAsm && this.selectedAsm !== this.ALL) ? this.selectedAsm : null,
          distributor_id: (this.selectedDistributor && this.selectedDistributor !== this.ALL) ? this.selectedDistributor : null,
          dealer_id: this.selectedDealer || null,
          start_date: formattedStartDate,
          end_date: formattedEndDate,
        };

        const response = await searchdealervisit(payload, this.token);
        this.complaintList = response?.data?.data || [];

        if (this.complaintList.length) {
          this.showSuccessToast("Report Generated Successfully");
        } else {
          this.showErrorToast("No data found for selected filters.");
        }
      } catch (error) {
        console.error("Error searching dealer:", error);
        this.showErrorToast(error?.response?.data?.message || "Search failed.");
      } finally {
        this.loading = false;
      }
    },

    // =========================
    // ✅ DATE FORMATTERS (keep same)
    // =========================
    formatDateForApi(dateString) {
      if (!dateString) return null;
      const date = new Date(dateString);
      if (isNaN(date)) return null;

      const year = date.getFullYear();
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const day = ("0" + date.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US");
    },

    // =========================
    // ✅ MODAL DETAILS (UNCHANGED)
    // =========================
    async visitDetails(dealerVisitId) {
      try {
        const response = await fetchDealerPopup(dealerVisitId, this.token);
        const data = response.data.data;

        this.modalTitle = "dealer_visit Visit Details";
        this.modalVisited = data.dealerVisit[0].visited;
        this.modalDealerName = data.dealerVisit[0].business_name;
        this.modalRemark = data.dealerVisit[0].remark;
        this.modalDateTimeValue = data.dealerVisit[0].created_at;

        this.modalChecklist = data.dealerCheckListDetails.map(item => ({
          id: item.id,
          name: item.checklists,
          list_value: item.list_value,
          details: item.details
        }));

        this.modalTableData = data.dealerVisititems.map(item => ({
          itemName: item.item_name,
          saleQty: item.sale_qty,
          refillQty: item.refil_qty,
          qty: item.empty_qty
        }));

        this.showModal = true;
      } catch (error) {
        console.error("Error fetching dealer visit details:", error);
        this.showErrorToast("Failed to load visit details.");
      }
    },

    exportToExcel() {
      if (!this.filteredComplaintList.length) return;

      // ===== FILTER SECTION =====
      const filterData = [
        ["Dealer Visit Report"],
        [],
        ["FSM", this.getName(this.fsmList, this.selectedFsm)],
        ["ASM", this.getName(this.asmList, this.selectedAsm)],
        ["Distributor", this.getName(this.distributorList, this.selectedDistributor)],
        ["Dealer", this.getName(this.dealerList, this.selectedDealer) || "All Dealers"],
        ["Start Date", this.startDate],
        ["End Date", this.endDate],
        [],
      ];

      // ===== TABLE DATA =====
      const tableData = [];

      this.filteredComplaintList.forEach(visit => {
        ["Sale Qty", "Empty Qty", "Refill Qty"].forEach(type => {
          const row = {
            "Dealer Name": visit.business_name,
            "Remark": visit.remark,
            "Date | Time": visit.created_at,
            "Visited by": visit.visited,
            "Type": type
          };

          // Add checklist values
          this.uniqueChecklists.forEach(check => {
            const val = visit.dealerCheckListDetails?.find(c => c.checklists === check.name)?.list_value;
            row[check.name] = val === "1" ? "Yes" : val === "0" ? "No" : "-";
          });

         // Add items values
          this.uniqueItems.forEach(item => {
            const valObj = visit.dealerVisititems?.find(i => i.item_id === item.id);
            row[item.name] =
              type === "Sale Qty"
                ? valObj?.sale_qty ?? "-"
                : type === "Empty Qty"
                ? valObj?.empty_qty ?? "-"
                : valObj?.refil_qty ?? "-";
          });

          tableData.push(row);
        });
      });

      // Convert to worksheet
      const ws = XLSX.utils.aoa_to_sheet(filterData);
      XLSX.utils.sheet_add_json(ws, tableData, { origin: "A10" });

      // ===== GENERATED SECTION =====
      const firstName = localStorage.getItem("first_name") || "";
      const lastName = localStorage.getItem("last_name") || "";
      const userFullName = `${firstName} ${lastName}`.trim() || "-";
      const generatedAt = new Date().toLocaleString();

      const generatedRows = [
        [], // empty row after table
        ["Generated By", userFullName],
        ["Generated At", generatedAt]
      ];

      const tableEndRow = 10 + tableData.length + 1;
      XLSX.utils.sheet_add_aoa(ws, generatedRows, { origin: `A${tableEndRow}` });

      // Create workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Dealer Visit Report");

      // Export file
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([wbout], { type: "application/octet-stream" });
      saveAs(blob, `DealerVisitReport_${new Date().toISOString().slice(0,10)}.xlsx`);
    },

    getName(list, id) {
      if (!id || id === this.ALL) return "All";
      const item = list.find(i => String(i.profile_id) === String(id));
      return item ? item.name : "";
    }
  }
};
</script>

<style scoped>
/* Ensure the body and html take the full height of the page */
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
  background-color: #f0f0f0;
  /* Background color for the page */
}

/* Container for the entire section */
.container {
  background-color: #ffffff;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 20px;
  margin: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  /* Center items vertically */
  height: auto;
  min-height: 100vh;
  /* Take full height of the page */
  width: 100%;
  /* Take full width of the page */
  box-sizing: border-box;
  /* Ensure padding doesn't affect width */
}

/* Loading spinner styles */
.loading-spinner {
  font-size: 18px;
  text-align: center;
  margin-top: 20px;
  color: #007bff;
  /* Preserved color for spinner */
}

/* Container for dropdowns and search box */
.dropdown-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  /* 4 columns for each row */
  gap: 15px;
  /* Adjust spacing between items */
  width: 100%;
  /* Ensure container takes full width */
  justify-content: center;
  /* Center dropdowns horizontally */
  margin-bottom: 20px;
  /* Space between dropdowns and table */
}

.table-responsive{
  width: 100%;
  max-height: 520px;     /* adjust as you want */
  overflow-y: auto;
  overflow-x: auto;
  border: 1px solid #ddd;
  -webkit-overflow-scrolling: touch;
}

/* Each dropdown item with label */
.dropdown-item {
  flex: 1;
  min-width: 180px;
  /* Minimum width for each dropdown item */
  max-width: 250px;
  /* Maximum width for each dropdown item */
}

/* Styling for labels */
label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 14px;
  /* Adjust font size for better readability */
}

/* Styling for select elements */
select {
  width: 100%;
  /* Ensure select takes full width of its container */
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  /* Adjust font size for better readability */
  transition: border-color 0.3s, box-shadow 0.3s;
}

input[type="date"] {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  width: 100%;
}

/* Focus styling for select elements */
select:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
  outline: none;
}

/* Styling for search input */
.search-input {
  flex: 1;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  /* Adjust font size for better readability */
  transition: border-color 0.3s, box-shadow 0.3s;
}

/* Focus styling for search input */
.search-input:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
  outline: none;
  /* Remove the default outline */
}

/* Styling for search button */
.search-container {
  display: flex;
  align-items: center;
  justify-content: left;
}


.btn.button-default {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  background-color: #007bff;
  color: #ffffff;
  font-size: 14px;
  /* Adjust font size for better readability */
  cursor: pointer;
  transition: background-color 0.3s, transform 0.3s;
}

.btn.button-default:hover {
  background-color: #0056b3;
  transform: scale(1.05);
}

.btn.button-default:active {
  transform: scale(0.95);
}

.export-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
  margin-left: 10px;
}

/* Table styling */
.table-container {
  width: 100%;
  margin-top: 20px;
}

.table {
  width: max-content;
  min-width: 100%;
  border-collapse: collapse;
  table-layout: auto;
}

.table th,
.table td {
  padding: 14px 18px;
  text-align: left;
  border-bottom: 1px solid #ddd;
  white-space: nowrap;
}

.table th {
  background-color: #f9f9f9;
  font-weight: bold;
  position: sticky;
  z-index: 1;
  top: 0;
}

.table td {
  background-color: #ffffff;
}

.border-right-main {
  border-right: 1px solid #000000;
}

.table th.no-bottom-border {
  border-bottom: none !important;
}

/* Popup styling */
.popup-content h3 {
  margin-top: 0;
}

.popup-content ul {
  list-style: none;
  padding: 0;
}

.popup-content li {
  margin-bottom: 10px;
}

.popup-content hr {
  border: 0;
  border-top: 1px solid #ddd;
  margin: 10px 0;
}

/* Optional: Add spacing and icon styling for the complaint messages */
.table td i.fa-flag {
  margin-right: 8px;
  /* Space between icon and text */
  color: red;
  /* Color of the flag icon */
}

/* Styling for the "eye" icon */
.fa-eye {
  cursor: pointer;
  transition: color 0.3s, transform 0.3s;
  /* Smooth transition for color and transform */
}

/* Hover effect for the "eye" icon */
.fa-eye:hover {
  color: #0056b3;
  /* Darker shade on hover */
  transform: scale(1.2);
  /* Slightly enlarge the icon on hover */
}

/* Active effect for the "eye" icon */
.fa-eye:active {
  transform: scale(1.1);
  /* Slightly shrink the icon on click */
}

/* Status color classes */
.status-pending {
  background-color: #FFC107;
  /* Yellow color */
  color: #FFFFFF;
  /* White text */
  padding: 5px 10px;
  border-radius: 5px;
}

.status-inprogress {
  background-color: #1B6CB4;
  /* blue color */
  color: #FFFFFF;
  /* White text */
  padding: 5px 10px;
  border-radius: 5px;
}

.status-completed {
  background-color: #069E27;
  /* Yellow color */
  color: #FFFFFF;
  /* White text */
  padding: 5px 10px;
  border-radius: 5px;
}
</style>